import { StandardEvents } from '@shopify/events';

function normalizeCartBadges() {
  const wrappers = document.querySelectorAll('[data-cart-wrapper]');
  wrappers.forEach((wrapper) => {
    if (!(wrapper instanceof HTMLElement)) return;

    const countElement = wrapper.querySelector('[data-cart-count]');
    const countText = countElement ? countElement.textContent || '' : '';
    const count = parseInt(countText, 10);

    if (!countElement || Number.isNaN(count) || count <= 0) {
      wrapper.setAttribute('data-count', '0');
      if (countElement instanceof HTMLElement) {
        countElement.textContent = '';
      }
      return;
    }

    wrapper.setAttribute('data-count', String(count));
  });
}

/**
 * @param {Event} event
 */
function onCartLinesUpdate(event) {
  const sideCart = document.getElementById('side-cart');
  const promise =
    event instanceof CustomEvent && event.detail && 'promise' in event.detail
      ? event.detail.promise
      : null;

  if (sideCart instanceof HTMLElement && promise instanceof Promise) {
    sideCart.setAttribute('aria-busy', 'true');
    promise.finally(() => {
      sideCart.removeAttribute('aria-busy');
    });
  }

  requestAnimationFrame(normalizeCartBadges);
}

document.addEventListener('DOMContentLoaded', normalizeCartBadges);
document.addEventListener('shopify:section:load', normalizeCartBadges);
document.addEventListener(StandardEvents.cartLinesUpdate, onCartLinesUpdate);
